import React from 'react'
import aboutme from '../img/about1.png'

const About = () => {
  return (
    <> 
  <div className='flex flex-col justify-center items-center my-0' id="about">
  <p className='text-4xl font-bold primary-color text-center mt-14'>About Us</p>
  <p className='text-gray-400 text-2xl text-center text-white'>
"Expert coder crafting efficient, innovative software solutions."</p>
</div>

    <div className='text-white max-w-[100%] mx-auto' >
    <div className='md:grid md:grid-cols-2 sm:py-16'>

<div className='md:mt-0 text-left flex flex-col h-full justify-start py-2 md:py-0'>
  <div className='my-auto mx-6'>
   
  <p className='lg:text-lg lg:-mt-20  text-justify glitter-text'>
    "As an undergraduate in Software Engineering, I am passionate about coding and technology. Currently, I am pursuing my final year of studies at the Java Institute for Advanced Technology.<br/><br/> My journey in software engineering has equipped me with strong skills in problem-solving, coding, and developing innovative software solutions. I thrive on creating efficient, reliable, and cutting-edge applications, continuously striving to expand my knowledge and expertise in this ever-evolving field."
    </p>
  </div>
</div>

<img className="mx-auto rounded-3xl py-4 md:py-0 lg:-mt-5" src={aboutme} width={300} height={200} alt=''/>

    </div>
    </div>
    </>
  )
}

export default About